import {
  SHAREFOLDERLIST
} from 'actions/shareFolder';
import {reducerPackage} from "../../utils";

export const shareFolderList = reducerPackage(SHAREFOLDERLIST);

